export const HEADING_COLOR_LIGHT = '#191e22'
export const HEADING_COLOR_DARK = '#fff'

export const TEXT_COLOR_LIGHT = '#2a454c'
export const TEXT_COLOR_DARK = '#696E77'
